/**
 * 绩效考核打分表定义（全部写死在前端，后端只存总分+明细JSON）
 * 依据：D:\work\公司文档\新OA绩效考核\OA评分表汇总（忠实转录，文档自身分档/权重矛盾的以权重为准）
 *
 * 表结构：
 *   key         唯一标识
 *   scene       评分场景（对应后端 PerfRule.SCENE_*）
 *   deptCodes   适用的部门 code（XWKD/GAOGUAN 不会出现在任务里）
 *   title       表名
 *   mode        SUM-各项直接相加；GROUP_WEIGHT-分组加权（组内相加×组权重再相加）
 *   groups      分组 [{ name, weight, items: [{ n-指标名, max-满分, req-指标要求, r-评分规则 }] }]
 *
 * 通用约定：
 *   95分以上（含）和70分以下须写明原因，否则视为无效分（后端强校验）
 *   部门90分以上人员不得超过20%（不足1人按1人计）——前端仅提示，不拦截
 */

// 三档评分规则简写：好|中|差（描述语按源文档统一为「按要求完成/个别差错，不影响整体实施/严重差错」）
// 五档态度(LV5)、四档互评(peerBands)为独立族不走本函数；个别三档项若描述特殊可绕过 band 直接写 r 原始串
function band(good, mid, bad) { return '按要求完成' + good + '|个别差错，不影响整体实施' + mid + '|严重差错' + bad }

// 态度类5级评分（责任心/领导力）
const LV5 = '1级10分|2级11-20分|3级21-30分|4级31-40分|5级41-50分'

// 互评四档（档位描述统一为「优秀/良好/合格/不合格」；每个 max 对应的档位区间）
function peerBands(max) {
  if (max === 15) return '优秀12-15|良好9-11|合格6-8|不合格3-5'
  if (max === 10) return '优秀8-10|良好5-7|合格4-6|不合格1-3'
  return ''
}

export const FORMS = [
  // ==================== 高管评部门（EXEC_DEPT） ====================
  {
    key: 'EXEC_DEPT_BIZ', scene: 'EXEC_DEPT', deptCodes: ['BIZ1', 'BIZ2'],
    title: '信贷业务部门考核评分表（高管评分）', mode: 'SUM',
    groups: [{ name: '评分项', weight: 1, items: [
      { n: '渠道维护', max: 20, req: '向业务渠道及时传达公司的相关规章制度，并能严格按照执行；协助业务渠道完善内部流程管理；建立并维护与渠道的合作关系。', r: band('15-20', '6-14', '0-5') },
      { n: '工作态度', max: 20, req: '部门员工认同公司企业文化，遵守公司规章制度，无记过和处罚；按时、按要求完成工作。', r: band('15-20', '6-14', '0-5') },
      { n: '协作能力', max: 20, req: '积极配合各部门各项工作，不拖沓、不推卸；部门内部分工明确，配合默契，互帮互助。', r: band('15-20', '6-14', '0-5') },
      { n: '团队建设', max: 20, req: '团队成员相对稳定，内部员工信息沟通、知识共享；建立健全内控制度，细化操作环节规章制度，改进完善工作程序，提高工作效率。', r: band('15-20', '6-14', '0-5') },
      { n: '工作计划', max: 20, req: '根据工作计划内容，按时按要求完成；非部门原因未完成的工作的不予扣减分。', r: band('15-20', '6-14', '0-5') }
    ]}]
  },
  {
    key: 'EXEC_DEPT_TEC', scene: 'EXEC_DEPT', deptCodes: ['TEC'],
    title: '信息科技部门考核评分表（高管评分）', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '任务指标 80%', weight: 0.8, items: [
        { n: '日常管理工作', max: 30, req: '制订和组织完成团队目标和工作计划；召开工作例会，组织专业技术和金融知识学习；搞好团队建设。', r: band('20-30', '10-19', '0-9') },
        { n: '系统开发及维护', max: 30, req: '根据公司发展需要及时推进系统开发、功能优化、流程优化；数据统计分析及时、稳定、准确。', r: band('20-30', '10-19', '0-9') },
        { n: '需求响应', max: 20, req: '收集需求、梳理需求、反馈结果及时，并按时完成；对需求从技术层面进行专业安全识别，提出化解和处置意见或提交公司办公会决策。', r: band('15-20', '6-14', '0-5') },
        { n: '熟悉公司业务', max: 20, req: '熟悉公司业务、风控流程及逻辑；熟悉公司财务放、收款、结息计算流程节点逻辑；熟悉行政日常工作内容、方法、意义等。', r: band('15-20', '6-14', '0-5') }
      ]},
      { name: '态度指标 20%', weight: 0.2, items: [
        { n: '责任心', max: 50, req: '1级：承认结果，而不是强调愿望；2级：承担责任，不推卸，不指责；3级：着手解决问题，减少工作流程；4级：举一反三，改进工作方式方法；5级：坚持原则，做事有预见，有防范意识', r: LV5 },
        { n: '领导力', max: 50, req: '1级：合理安排员工工作；2级：能正确评价员工的付出与回报；3级：对员工业绩与态度进行客观评价；4级：熟练掌握岗位工作，带领引导员工积极工作；5级：影响力大，员工自愿追随并付出贡献', r: LV5 }
      ]}
    ]
  },
  {
    key: 'EXEC_DEPT_PAG', scene: 'EXEC_DEPT', deptCodes: ['PAG'],
    title: '党政综合部门考核评分表（高管评分）', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '工作能力 70%', weight: 0.7, items: [
        { n: '日常管理工作', max: 20, req: '制订和组织完成部门目标和工作计划；召开工作例会；组织业务学习；搞好团队建设；检查督促公司总经理办公会议和领导布置的工作任务的贯彻落实情况。', r: band('15-20', '6-14', '0-5') },
        { n: '部门制度建设', max: 20, req: '建立健全公司的薪酬福利、绩效考核等体系，公司行政规章制度的制定、监督、执行，收集和了解公司各部门的工作动态。', r: band('15-20', '6-14', '0-5') },
        { n: '人力资源管理', max: 20, req: '负责公司行政人力资源管理工作，员工招聘、培训、考核、劳动关系管理等。', r: band('15-20', '6-14', '0-5') },
        { n: '资产管理', max: 20, req: '负责公司固定资产、办公用品、车辆、通讯、报刊订阅、办公环境、办公网络及信息资源等行政事务管理，公司网站建设、计算机等设备的运行及维护工作。', r: band('15-20', '6-14', '0-5') },
        { n: '安全管理', max: 10, req: '负责公司的安保工作及保密工作。', r: band('8-10', '4-7', '0-3') },
        { n: '工作计划', max: 10, req: '根据工作计划内容，按时按要求完成；非部门原因未完成的工作的不予扣减分。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '工作表现 30%', weight: 0.3, items: [
        { n: '协作能力', max: 30, req: '积极配合各部门各项工作，不拖沓、不推卸；部门内部分工明确，配合默契，互帮互助', r: band('20-30', '10-19', '0-9') },
        { n: '工作态度', max: 40, req: '部门员工认同公司企业文化，遵守公司规章制度，无记过和处罚；按时、按要求完成工作。', r: band('30-40', '15-29', '0-14') },
        { n: '团队建设', max: 30, req: '团队成员相对稳定，内部员工信息沟通、知识共享；建立健全内控制度，细化操作环节规章制度，改进完善工作程序，提高工作效率，不断提高团队业务素质。', r: band('20-30', '10-19', '0-9') }
      ]}
    ]
  },
  {
    key: 'EXEC_DEPT_FIN', scene: 'EXEC_DEPT', deptCodes: ['FIN'],
    title: '计划财务部门考核评分表（高管评分）', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '工作能力 70%', weight: 0.7, items: [
        { n: '日常管理工作', max: 20, req: '制订和组织完成部门目标和工作计划；召开工作例会；组织业务学习；搞好团队建设。', r: band('15-20', '6-14', '0-5') },
        { n: '财务工作', max: 30, req: '负责公司的财务核算、财务预算、财务决算及财务基础工作，对公司的费用及成本进行管理和控制，公司财务分析工作。', r: band('20-30', '10-19', '0-9') },
        { n: '部门制度建设', max: 20, req: '负责建立公司财务核算体系及相关制度，并监督执行，执行国家财经法规及相关财务制度，保障公司的资金安全及需求。', r: band('15-20', '6-14', '0-5') },
        { n: '考核人员', max: 10, req: '管理并考核公司财务人员，组织公司财务人员的再教育和培训工作，不断提高财务人员的职业道德和业务素质。', r: band('8-10', '4-7', '0-3') },
        { n: '掌握政策', max: 10, req: '负责研究各级政府部门对小贷行业的各项扶持和优惠政策，及时掌握政策动态，负责办理和落实各项政策补贴。', r: band('8-10', '4-7', '0-3') },
        { n: '工作计划', max: 10, req: '根据工作计划内容，按时按要求完成；非部门原因未完成的工作的不予扣减分。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '工作表现 30%', weight: 0.3, items: [
        { n: '协作能力', max: 30, req: '积极配合各部门各项工作，不拖沓、不推卸；部门内部分工明确，配合默契，互帮互助', r: band('20-30', '10-19', '0-9') },
        { n: '工作态度', max: 40, req: '部门员工认同公司企业文化，遵守公司规章制度，无记过和处罚；按时、按要求完成工作。', r: band('30-40', '15-29', '0-14') },
        { n: '团队建设', max: 30, req: '团队成员相对稳定，内部员工信息沟通、知识共享；建立健全内控制度，细化操作环节规章制度，改进完善工作程序，提高工作效率，不断提高团队业务素质。', r: band('20-30', '10-19', '0-9') }
      ]}
    ]
  },
  {
    key: 'EXEC_DEPT_RISK', scene: 'EXEC_DEPT', deptCodes: ['RISK'],
    title: '风险控制部门考核评分表（高管评分）', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '工作能力 70%', weight: 0.7, items: [
        { n: '日常管理工作', max: 20, req: '制订和组织完成部门目标和工作计划；召开工作例会；组织业务学习；搞好团队建设。', r: band('15-20', '6-14', '0-5') },
        { n: '部门制度建设', max: 20, req: '协助分管领导制定公司的业务管理目标、风险管理制度等；建立、完善各项业务的管理体系、制度、办法等，法律、法规的正确适用。', r: band('15-20', '6-14', '0-5') },
        { n: '项目评审', max: 20, req: '对业务部报送的项目，组织本部门进行风险评审，并出具评审意见，管理业务部门移交的不良贷款，包括针对不良贷款的诉讼、清收、抵债资产的接收和处置、呆账核销的审查等。', r: band('15-20', '6-14', '0-5') },
        { n: '风险识别', max: 20, req: '对业务部门报告的风险预警信息进行识别，提出化解和处置意见或提交公司办公会决策。', r: band('15-20', '6-14', '0-5') },
        { n: '关系维护', max: 10, req: '协调与法院的关系。', r: band('8-10', '4-7', '0-3') },
        { n: '工作计划', max: 10, req: '根据工作计划内容，按时按要求完成；非部门原因未完成的工作的不予扣减分。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '工作表现 30%', weight: 0.3, items: [
        { n: '协作能力', max: 30, req: '积极配合各部门各项工作，不拖沓、不推卸；部门内部分工明确，配合默契，互帮互助', r: band('20-30', '10-19', '0-9') },
        { n: '工作态度', max: 40, req: '部门员工认同公司企业文化，遵守公司规章制度，无记过和处罚；按时、按要求完成工作。', r: band('30-40', '15-29', '0-14') },
        { n: '团队建设', max: 30, req: '团队成员相对稳定，内部员工信息沟通、知识共享；建立健全内控制度，细化操作环节规章制度，改进完善工作程序，提高工作效率，不断提高团队业务素质。', r: band('20-30', '10-19', '0-9') }
      ]}
    ]
  },

  // ==================== 部门负责人评其他部门（LEADER_DEPT，通用一张表） ====================
  {
    key: 'LEADER_DEPT_COMMON', scene: 'LEADER_DEPT', deptCodes: ['BIZ1', 'BIZ2', 'TEC', 'PAG', 'FIN', 'RISK'],
    title: '部门季度考核评分表', mode: 'SUM',
    groups: [{ name: '评分项', weight: 1, items: [
      { n: '工作效率', max: 20, req: '及时完成送达的工作任务；按计划和质量要求及时完成相关工作；按公司部门工作流程要求做好相关工作。', r: band('15-20', '6-14', '0-5') },
      { n: '工作态度', max: 30, req: '部门员工认同公司企业文化，遵守公司规章制度；工作积极主动，按时、按要求完成各项工作。', r: band('20-30', '10-19', '0-9') },
      { n: '协作态度', max: 30, req: '在合作开展工作时能否以大局为重，积极协作发挥作用；正确对待合作开展工作时出现的问题和矛盾；积极配合各部门各项工作，不拖沓、不推卸。', r: band('20-30', '10-19', '0-9') },
      { n: '团队建设', max: 20, req: '团队成员相对稳定，内部员工信息沟通、知识共享；建立健全内控制度，细化操作环节规章制度，改进完善工作程序，提高工作效率，不断提高团队业务素质。', r: band('15-20', '6-14', '0-5') }
    ]}]
  },

  // ==================== 员工评本部门负责人（EMP_LEADER） ====================
  {
    key: 'EMP_LEADER_BIZ', scene: 'EMP_LEADER', deptCodes: ['BIZ1', 'BIZ2'],
    title: '信贷业务部负责人考核表', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '任务指标 80%', weight: 0.8, items: [
        { n: '日常管理工作', max: 30, req: '组织、落实、完成办公网点工作，并向分管领导报告工作；主持召开网点工作会议，听取员工合理性建议。', r: band('20-30', '10-19', '0-9') },
        { n: '协调管理', max: 20, req: '合理分配部门及网点工作，指导并监督、检查落实情况，解决协调网点内部问题。', r: band('15-20', '6-14', '0-5') },
        { n: '项目管理', max: 20, req: '对本部门业务经理提交的《调查报告》、贷前调查资料、贷后检查报告进行全面审查、认定，并签署意见，对检查监督中发现的问题及时处理上报，确保发放贷款本息按期收回，不形成不良贷款。', r: band('15-20', '6-14', '0-5') },
        { n: '团队管理', max: 20, req: '完善内部（含网点）岗位职责，建立健全网点内控制度，细化操作环节规章制度，改进完善工作程序，提高工作效率，不断提高团队成员业务素质。', r: band('15-20', '6-14', '0-5') },
        { n: '关系维护', max: 10, req: '协调、维护对内、对外的工作。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '态度指标 20%', weight: 0.2, items: [
        { n: '责任心', max: 50, req: '1级：承认结果，而不是强调愿望；2级：承担责任，不推卸，不指责；3级：着手解决问题，减少业务流程；4级：举一反三，改进业务流程；5级：坚持原则，做事有预见，有防误设计', r: LV5 },
        { n: '领导力', max: 50, req: '1级：任命员工合理；2级：能正确评价员工付出与回报协调性；3级：对员工业绩与态度进行客观评价；4级：掌握岗位精确工作技术，培训员工为胜任力者；5级：影响力大，员工自愿追随并付出贡献', r: LV5 }
      ]}
    ]
  },
  {
    key: 'EMP_LEADER_TEC', scene: 'EMP_LEADER', deptCodes: ['TEC'],
    title: '信息科技部负责人考核评分表', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '任务指标 80%', weight: 0.8, items: [
        { n: '日常工作', max: 30, req: '制订和组织完成团队目标和工作计划；召开工作例会，及时传达公司办公会决定；组织专业技术和金融知识学习，搞好团队建设。', r: band('20-30', '10-19', '0-9') },
        { n: '熟悉公司业务', max: 30, req: '熟悉公司业务、风控流程及逻辑；熟悉公司财务放、收款，结息计算流程节点逻辑；熟悉行政日常工作内容、方法、意义等。', r: band('20-30', '10-19', '0-9') },
        { n: '专业技术', max: 20, req: '对系统建设和规划提出建设性意见；从技术层面进行专业安全识别，提出化解和处置意见。', r: band('15-20', '6-14', '0-5') },
        { n: '沟通协调', max: 20, req: '团队内、外部的沟通和对接无障碍，人际关系融洽。', r: band('15-20', '6-14', '0-5') }
      ]},
      { name: '态度指标 20%', weight: 0.2, items: [
        { n: '责任心', max: 50, req: '1级：承认结果，而不是强调愿望；2级：承担责任，不推卸，不指责；3级：着手解决问题，减少工作流程；4级：举一反三，改进工作方式方法；5级：坚持原则，做事有预见，有防范意识', r: LV5 },
        { n: '领导力', max: 50, req: '1级：合理安排员工工作；2级：能正确评价员工的付出与回报；3级：对员工业绩与态度进行客观评价；4级：熟练掌握岗位工作，带领引导员工积极工作；5级：影响力大，员工自愿追随并付出贡献', r: LV5 }
      ]}
    ]
  },
  {
    key: 'EMP_LEADER_PAG', scene: 'EMP_LEADER', deptCodes: ['PAG'],
    title: '党政综合部负责人考核评分表', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '任务指标 80%', weight: 0.8, items: [
        { n: '日常管理工作', max: 30, req: '制订和组织完成部门目标和工作计划；召开工作例会；组织业务学习；搞好团队建设；检查督促公司总经理办公会议和领导布置的工作任务的贯彻落实情况；负责外部单位、机构的日常联系和关系维护。', r: band('20-30', '10-19', '0-9') },
        { n: '部门制度建设', max: 20, req: '建立健全公司的薪酬福利、绩效考核等体系，公司行政规章制度的制定、监督、执行，收集和了解公司各部门的工作动态。', r: band('15-20', '6-14', '0-5') },
        { n: '人力资源管理', max: 20, req: '负责公司行政人力资源管理工作，员工招聘、培训、考核、劳动关系管理等。', r: band('15-20', '6-14', '0-5') },
        { n: '资产管理', max: 20, req: '负责公司固定资产、办公用品、车辆、通讯、报刊订阅、办公环境、办公网络及信息资源等行政事务管理，公司公众号、网站、OA系统、计算机等系统设备的运行及维护工作。', r: band('15-20', '6-14', '0-5') },
        { n: '安全管理', max: 10, req: '负责公司的安保、保密等工作。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '定性指标 20%', weight: 0.2, items: [
        { n: '责任心', max: 50, req: '1级：承认结果，而不是强调愿望；2级：承担责任，不推卸，不指责；3级：着手解决问题，减少业务流程；4级：举一反三，改进业务流程；5级：坚持原则，做事有预见，有防误设计', r: LV5 },
        { n: '领导力', max: 50, req: '1级：任命员工合理；2级：能正确评价员工付出与回报协调性；3级：对员工业绩与态度进行客观评价；4级：掌握岗位精确工作技术，培训员工为胜任力者；5级：影响力大，员工自愿追随并付出贡献', r: LV5 }
      ]}
    ]
  },
  {
    key: 'EMP_LEADER_FIN', scene: 'EMP_LEADER', deptCodes: ['FIN'],
    title: '计划财务部负责人考核表', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '定量指标 80%', weight: 0.8, items: [
        { n: '日常管理工作', max: 20, req: '制订和组织完成部门目标和工作计划；召开工作例会；组织业务学习；搞好团队建设。', r: band('15-20', '6-14', '0-5') },
        { n: '财务工作', max: 30, req: '负责公司的财务核算、财务预算、财务决算及财务基础工作，对公司的费用及成本进行管理和控制，公司财务分析工作。', r: band('20-30', '10-19', '0-9') },
        { n: '部门制度建设', max: 30, req: '负责建立公司财务核算体系及相关制度，并监督执行，执行国家财经法规及相关财务制度，保障公司的资金安全及需求。', r: band('20-30', '10-19', '0-9') },
        { n: '团队管理', max: 10, req: '管理并考核公司财务人员，组织公司财务人员的再教育和培训工作，不断提高财务人员的职业道德和业务素质。', r: band('8-10', '4-7', '0-3') },
        { n: '掌握政策', max: 10, req: '负责研究各级政府部门对小贷行业的各项扶持和优惠政策，及时掌握政策动态，负责办理和落实各项政策补贴。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '定性指标 20%', weight: 0.2, items: [
        { n: '责任心', max: 50, req: '1级：承认结果，而不是强调愿望；2级：承担责任，不推卸，不指责；3级：着手解决问题，减少业务流程；4级：举一反三，改进业务流程；5级：坚持原则，做事有预见，有防误设计', r: LV5 },
        { n: '领导力', max: 50, req: '1级：任命员工合理；2级：能正确评价员工付出与回报协调性；3级：对员工业绩与态度进行客观评价；4级：掌握岗位精确工作技术，培训员工为胜任力者；5级：影响力大，员工自愿追随并付出贡献', r: LV5 }
      ]}
    ]
  },
  {
    key: 'EMP_LEADER_RISK', scene: 'EMP_LEADER', deptCodes: ['RISK'],
    title: '风险控制部负责人考核评分表', mode: 'GROUP_WEIGHT',
    groups: [
      { name: '任务指标 80%', weight: 0.8, items: [
        { n: '日常管理工作', max: 30, req: '制订和组织完成部门目标和工作计划；召开工作例会；组织业务学习；搞好团队建设。', r: band('20-30', '10-19', '0-9') },
        { n: '部门制度建设', max: 20, req: '协助分管领导制定公司的信贷风险管理目标、风险管理制度等；建立、完善各项业务的风险管理体系、制度、办法等，法律、法规的正确适用。', r: band('15-20', '6-14', '0-5') },
        { n: '项目评审、风险识别', max: 20, req: '对业务部报送的项目，组织本部门进行风险评审，并出具评审意见；对业务部门报告的风险预警信息进行识别，提出化解和处置意见或提交公司办公会决策。', r: band('15-20', '6-14', '0-5') },
        { n: '贷后管理', max: 20, req: '管理业务部门移交的不良贷款，包括针对不良贷款的诉讼、清收、抵债资产的接收和处置、呆账核销的审查等。', r: band('15-20', '6-14', '0-5') },
        { n: '关系维护', max: 10, req: '协调、维护对内、对外的工作。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '态度指标 20%', weight: 0.2, items: [
        { n: '责任心', max: 50, req: '1级：承认结果，而不是强调愿望；2级：承担责任，不推卸，不指责；3级：着手解决问题，减少业务流程；4级：举一反三，改进业务流程；5级：坚持原则，做事有预见，有防误设计', r: LV5 },
        { n: '领导力', max: 50, req: '1级：任命员工合理；2级：能正确评价员工付出与回报协调性；3级：对员工业绩与态度进行客观评价；4级：掌握岗位精确工作技术，培训员工为胜任力者；5级：影响力大，员工自愿追随并付出贡献', r: LV5 }
      ]}
    ]
  }
]

// ==================== 员工互评表（ALL_PEER 全员互评默认表；部门内互评 EMP_PEER 改用岗位 kpi_form_key，与负责人评员工同表） ====================
export const PEER_FORM = {
  key: 'PEER_COMMON', scene: 'EMP_PEER', deptCodes: [],
  title: '员工互评表', mode: 'SUM',
  groups: [{ name: '评分项', weight: 1, items: [
    { n: '工作责任感（15%）', max: 15, req: '1.对所负责的工作有强烈的责任心且积极付诸行动，善于发现问题，勇于纠错。2.责任心强，能清楚地知道自己的责任，工作积极。3.责任心不强，遇事推诿不敢承担错误。4.有一定的责任心，并敢于对自己的工作负责，知错就改。', r: peerBands(15) },
    { n: '工作任务（15%）', max: 15, req: '1.能保质保量，提前完成任务。2.能保质保量，按时完成任务。3.在监督下能完成任务。4.在指导下，偶尔不能完成任务。', r: peerBands(15) },
    { n: '纪律性（15%）', max: 15, req: '1.自觉遵守和维护公司各项规章制度。2.能遵守公司规章制度，但需要有人督导。3.纪律观念不强，偶尔违反公司规章制度。4.经常违反公司制度，被指正时态度傲慢。', r: peerBands(15) },
    { n: '创新能力（10%）', max: 10, req: '1.能加强工作反思，积极主动地推动创新工作。2.富有创新，态度积极。3.有创新意识，能改进自己的工作。4.对待工作按部就班，少创新。', r: peerBands(10) },
    { n: '工作效率（15%）', max: 15, req: '1.工作效率高，完成任务速度快，质量高。2.工作效率较高，能及时保质保量完成任务。3.工作效率一般，能按时完成任务，基本保证质量。4.工作效率不高，质量时有差错。', r: peerBands(15) },
    { n: '积极性（15%）', max: 15, req: '1.能积极主动地执行工作任务，任劳任怨，勇于挑战，为完成工作目标竭尽全力。2.有一定上进心，善于把所学知识用于实践，为完成工作任务而努力。3.能以良好的心态面对所交付的工作。4.遇到问题和困难时斗志不强。', r: peerBands(15) },
    { n: '团队观念（15%）', max: 15, req: '1.非常热爱集体、积极参加团队活动，很强的集体荣誉感。2.很热爱集体、很好的参与团队活动，较好的集体荣誉感。3.集体意识一般，团队活动参与性不强，集体荣誉感较强。4.不爱参加团队活动。', r: peerBands(15) }
  ]}],
  note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' }

// ==================== KPI 评分表（LEADER_EMP 负责人评员工，按部门+岗位） ====================
const KPI = { scene: 'LEADER_EMP' }
export const KPI_FORMS = [
  // ---- 业务部 ----
  { ...KPI, key: 'KPI_BIZ_MANAGER', deptCodes: ['BIZ1', 'BIZ2'],
    title: '业务经理岗KPI评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '销售业绩-完成率', max: 30, req: '实际完成销售额÷计划完成销售额×100%', r: band('26-30', '15-25', '0-14') },
        { n: '销售业绩-客户开发', max: 20, req: '负责客户的引荐和发展，业务推荐单位的开发与维护；负责新产品的开发与市场推广；负责客户贷款初步方案或调查报告的撰写', r: band('16-20', '10-15', '0-9') },
        { n: '客户管理-贷前', max: 10, req: '贷前业务的管理：包括资料收集、业务审核、面谈客户、下户考察、陪查征信、陪打流水、陪打婚档、陪打房屋全档、录入系统等', r: band('8-10', '5-7', '0-4') },
        { n: '客户管理-贷中', max: 10, req: '贷中业务的管理：跟踪、服务、维护在贷客户，动态了解客户情况及贷款本息到期提醒等', r: band('8-10', '5-7', '0-4') },
        { n: '客户管理-贷后', max: 10, req: '贷后业务管理：包括贷后日常检查，逾期客户本息催收、提额、续贷、展期、后期配合司法程序、逾期处理、贷款结清等', r: band('8-10', '5-7', '0-4') },
        { n: '沟通应变-判断力', max: 5, req: '能迅速的对客观环境做出较为正确的判断，并能灵活运用到实际工作中取得较好的销售业绩', r: band('4-5', '2-3', '0-1') },
        { n: '沟通应变-技巧', max: 5, req: '能灵活运用多种谈话技巧和他人进行沟通，应对客观环境的变化，能灵活的采取相应的措施', r: band('4-5', '2-3', '0-1') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '工作态度-积极性', max: 5, req: '是否具有工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '工作态度-纪律', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_BIZ_ASSISTANT', deptCodes: ['BIZ1', 'BIZ2'],
    title: '业务内勤岗KPI评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 80%', weight: 1, items: [
        { n: '日常工作-台账文档', max: 10, req: '部门文件台账管理、文档处理、文档保管、资料保密', r: band('8-10', '5-7', '0-4') },
        { n: '日常工作-内部协助', max: 10, req: '协助部门人员、公司内部处理事项，与外部人员工作对接', r: band('8-10', '5-7', '0-4') },
        { n: '日常工作-逾期跟踪', max: 10, req: '参与逾期贷款跟踪、日常检查，督促客户经理即时处理逾期贷款', r: band('8-10', '5-7', '0-4') },
        { n: '日常工作-其他事项', max: 10, req: '部门内勤事务及交办的其他事项', r: band('8-10', '5-7', '0-4') },
        { n: '沟通应变-判断力', max: 20, req: '能迅速的对客观环境做出较为正确的判断，并能灵活运用到实际工作中取得较好的业绩', r: band('16-20', '10-15', '0-9') },
        { n: '沟通应变-技巧', max: 20, req: '能灵活运用多种谈话技巧和他人进行沟通，应对客观环境的变化，能灵活的采取相应的措施', r: band('16-20', '10-15', '0-9') }
      ]},
      { name: '态度指标 20%', weight: 1, items: [
        { n: '工作态度-积极性', max: 10, req: '工作积极性与主动性', r: band('8-10', '5-7', '0-4') },
        { n: '工作态度-纪律', max: 10, req: '是否严格遵守公司及部门各项行政纪律', r: band('8-10', '5-7', '0-4') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  // ---- 党政综合部（行政部） ----
  { ...KPI, key: 'KPI_PAG_WENMI', deptCodes: ['PAG'],
    title: '行政文秘考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '会议纪要', max: 30, req: '负责公司会议的组织、会议材料准备、会议纪要记录整理、会议决议执行情况督查。负责公司日常事件、活动的记录，编写简报。负责组织起草行政综合文件、报告、通知等文件。', r: band('21-30', '11-20', '0-10') },
        { n: '档案管理', max: 20, req: '负责办公室的文件、信息、机要和保密工作，做好档案收集、整理工作。', r: band('15-20', '6-14', '0-5') },
        { n: '网站、公众号管理', max: 20, req: '负责公司网站、公众号撰写、排版、维护等。', r: band('15-20', '6-14', '0-5') },
        { n: '部门制度建设', max: 10, req: '协助完善公司行政各项管理规章制度。', r: band('8-10', '4-7', '0-3') },
        { n: '其他工作', max: 10, req: '公司活动的策划与组织，物资的采购以及其他交办的任务。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '工作态度-积极性', max: 5, req: '工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '工作态度-纪律', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_PAG_HR', deptCodes: ['PAG'],
    title: '人事综合考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '日常管理工作', max: 20, req: '负责公司相关通知文件的编写，协助各部门推进部门人事管理工作，员工关怀等工作；协助部门负责人完工部门各项工作。', r: band('15-20', '6-14', '0-5') },
        { n: '人力资源管理', max: 20, req: '负责人力资源规划、人事招聘、培训、考核、劳动关系等工作。', r: band('15-20', '6-14', '0-5') },
        { n: '薪酬、绩效管理', max: 20, req: '完成每月的工资核算及薪酬发放，负责公司季度与年度考核方案的制定与执行，考核结果的汇总、兑现等工作。', r: band('15-20', '6-14', '0-5') },
        { n: '部门制度建设', max: 20, req: '协助拟订公司薪酬方案、人事管理制度、管理办法等人事制度。', r: band('15-20', '6-14', '0-5') },
        { n: '其他工作', max: 10, req: '办公用品的申购、领用及库存管理，公司各类活动的策划、组织以及其他交办的任务', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '责任心', max: 5, req: '工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '积极性', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_PAG_GENERAL', deptCodes: ['PAG'],
    title: '行政综合考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '日常管理工作', max: 10, req: '房租、物管费、花卉、保洁等硬度款项的缴纳。', r: band('8-10', '4-7', '0-3') },
        { n: '招标管理', max: 20, req: '负责招标采购项目的组织及实施、招标代理机构的对接、招标工作小组及招标办公室其他工作。', r: band('15-20', '6-14', '0-5') },
        { n: '资产管理', max: 20, req: '办公设备及低值易耗品、车辆、通讯、报刊、办公环境等后勤事务的管理；公司网站、计算机等设备的运行与维护', r: band('15-20', '6-14', '0-5') },
        { n: '部门制度建设', max: 20, req: '协助拟订公司薪酬方案、人事管理制度、管理办法等人事制度。', r: band('15-20', '6-14', '0-5') },
        { n: '档案管理', max: 20, req: '负责公司行政人事档案、对外文件和贷款结清项目档案的归档和管理工作。', r: band('15-20', '6-14', '0-5') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '责任心', max: 5, req: '工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '积极性', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_PAG_PARTY', deptCodes: ['PAG'],
    title: '党务专员考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '日常党务工作', max: 30, req: '筹备组织"三会一课"、主题党日等组织生活并做好记录归档；承担党员教育管理、发展培养、组织关系转接与党费收缴工作；起草党建计划、总结、报告等各类文字材料；对接上级党组织落实工作部署并报送材料', r: band('21-30', '11-20', '0-10') },
        { n: '党建宣传与组织工作', max: 30, req: '开展党建宣传与党风廉政教育；组织主题教育及党建特色活动，推动党建业务融合', r: band('21-30', '11-20', '0-10') },
        { n: '支部档案管理', max: 20, req: '负责党支部文件、信息、机要和保密工作，做好档案收集、整理工作。', r: band('15-20', '6-14', '0-5') },
        { n: '其他工作', max: 10, req: '协同群团工作，完成部门交办的其他党务与综合行政事务。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '工作态度-积极性', max: 5, req: '工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '工作态度-纪律', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_PAG_WENMI_HR', deptCodes: ['PAG'],
    title: '文秘（人事）考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '三会工作', max: 25, req: '负责公司会议的组织、会议材料准备、会议纪要记录整理、会议决议执行情况督查。负责公司日常事件、活动的记录，编写简报。负责组织起草行政综合文件、报告、通知等文件。', r: band('18-25', '9-17', '0-8') },
        { n: '人力资源管理', max: 25, req: '负责人力资源规划、人事招聘、培训、考核、劳动关系等工作；负责每月的工资核算及薪酬发放；负责公司季度与年度考核方案的制定与执行，考核结果的汇总、兑现等工作；协助各部门推进部门人事管理工作，员工关怀等工作。', r: band('18-25', '9-17', '0-8') },
        { n: '档案管理', max: 10, req: '负责收发文管理，办公室的文件、信息、机要和保密工作，做好档案收集、整理工作。', r: band('8-10', '4-7', '0-3') },
        { n: '网站、公众号管理', max: 10, req: '负责公司网站、公众号撰写、排版、维护等。', r: band('8-10', '4-7', '0-3') },
        { n: '部门制度建设', max: 10, req: '协助拟订并完善公司章程、三会议事规则、薪酬方案、人事管理制度、管理办法等行政人事各项管理规章制度。', r: band('8-10', '4-7', '0-3') },
        { n: '其他工作', max: 10, req: '协助部门负责人完成其他交办的任务。', r: band('8-10', '4-7', '0-3') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '工作态度-积极性', max: 5, req: '工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '工作态度-纪律', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  // ---- 风险控制部 ----
  { ...KPI, key: 'KPI_RISK_MANAGER', deptCodes: ['RISK'],
    title: '风险经理KPI评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 80%', weight: 1, items: [
        { n: '贷款调查及产品设计-风控审查', max: 15, req: '严格执行公司风控制度、贷款流程，严格审查项目', r: band('11-15', '6-10', '0-5') },
        { n: '贷款调查及产品设计-业务开发', max: 15, req: '参与公司新业务的开发设计；参与公司现有业务产品的更新升级', r: band('11-15', '6-10', '0-5') },
        { n: '贷款审查-审查尺度', max: 10, req: '审查尺度是否适当、是否坚持原则并避免本位主义，平衡风险控制与业务发展', r: band('8-10', '5-7', '0-4') },
        { n: '贷款审查-规范性', max: 10, req: '贷款审查、出具审查报告及其他临时性工作的规范性、时效性、准确性', r: band('8-10', '5-7', '0-4') },
        { n: '贷后管理-检查报告', max: 15, req: '严格按照贷后管理规定进行贷后管理，并认真完成贷后检查报告', r: band('11-15', '6-10', '0-5') },
        { n: '贷后管理-风险化解', max: 15, req: '贷款逾期或发生不良后是否及时提出处置意见并采用积极措施化解风险', r: band('11-15', '6-10', '0-5') }
      ]},
      { name: '态度指标 20%', weight: 1, items: [
        { n: '工作态度-积极性', max: 10, req: '工作积极性与主动性', r: band('8-10', '5-7', '0-4') },
        { n: '工作态度-纪律', max: 10, req: '是否严格遵守公司及部门各项行政纪律', r: band('8-10', '5-7', '0-4') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_RISK_LEGAL', deptCodes: ['RISK'],
    title: '法务专员考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '法律文书审核-草拟', max: 20, req: '草拟合同及法律文书，保证其准确、规范', r: band('15-20', '10-14', '0-9') },
        { n: '法律文书审核-合同审核', max: 20, req: '严格、按时审核合同的完整、规范、齐全', r: band('15-20', '10-14', '0-9') },
        { n: '法律文书审核-公证办理', max: 10, req: '联系公证处办理合同公证并按时回收公证合同', r: band('8-10', '4-7', '0-3') },
        { n: '法律文书审核-合同台账', max: 10, req: '建立合同台账并认真及时登记合同台账', r: band('8-10', '4-7', '0-3') },
        { n: '法务审查-参与审查', max: 10, req: '参与公司法务审查', r: band('8-10', '4-7', '0-3') },
        { n: '法务审查-风险处置', max: 15, req: '贷款发生风险后积极采用相应法律措施处置贷款风险', r: band('11-15', '6-10', '0-5') },
        { n: '法务审查-法务咨询', max: 5, req: '协助公司相关法务咨询', r: band('4-5', '2-3', '0-1') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '工作态度-积极性', max: 5, req: '工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '工作态度-纪律', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_RISK_GENERAL', deptCodes: ['RISK'],
    title: '风控综合考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '信贷档案资料管理', max: 45, req: '信贷档案资料的归集、整理是否及时、齐全', r: band('30-45', '15-29', '0-14') },
        { n: '权利凭证保管', max: 35, req: '相关权利凭证及其他重要物品的保管和登记是否及时、准确、无误', r: band('20-35', '10-29', '0-9') },
        { n: '其他工作', max: 10, req: '其他风控部综合事务及领导交办的事宜', r: band('7-10', '3-6', '0-2') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '工作态度-积极性', max: 5, req: '工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '工作态度-纪律', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_RISK_SECRETARY', deptCodes: ['RISK'],
    title: '风控综合（兼贷审会秘书）考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '风控综合-档案资料', max: 30, req: '信贷档案资料的归集、整理是否及时、齐全', r: band('20-30', '10-19', '0-9') },
        { n: '风控综合-凭证保管', max: 20, req: '相关权利凭证及其他重要物品的保管和登记是否及时、准确、无误', r: band('10-20', '5-9', '0-4') },
        { n: '风控综合-其他事务', max: 10, req: '其他风控部综合事务及领导交办的事宜', r: band('8-10', '4-7', '0-3') },
        { n: '贷审会秘书-资料整理', max: 10, req: '贷审会相关资料的整理、归档及会议时间的安排', r: band('8-10', '4-7', '0-3') },
        { n: '贷审会秘书-成员联系', max: 5, req: '贷审会成员的联系组织', r: band('4-5', '2-3', '0-1') },
        { n: '贷审会秘书-投票统计', max: 10, req: '贷审会会议投票结果的统计以及贷审会会议记录', r: band('8-10', '4-7', '0-3') },
        { n: '贷审会秘书-其他工作', max: 5, req: '贷审会安排的其他工作', r: band('4-5', '2-3', '0-1') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '工作态度-积极性', max: 5, req: '工作积极性与主动性', r: band('4-5', '2-3', '0-1') },
        { n: '工作态度-纪律', max: 5, req: '是否严格遵守公司及部门各项行政纪律', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  // ---- 信息科技部 ----
  { ...KPI, key: 'KPI_TEC_IT', deptCodes: ['TEC'],
    title: 'IT岗考核评分表', mode: 'GROUP_WEIGHT', showWeight: true, formula: '总分：（能力考核得分×90%）+（态度考核得分×10%）',
    groups: [
      { name: '能力指标 90%', weight: 0.9, norm: true, items: [
        { n: '工作结果考核-业务熟悉', max: 20, req: '熟悉掌握公司业务及系统框架；熟悉公司业务、风控流程及逻辑；熟悉公司财务放、收款、结息计算流程节点逻辑。', r: band('16-20', '11-15', '0-10') },
        { n: '工作结果考核-沟通对接', max: 15, req: '与公司内部相关部门及外部技术合作单位的沟通和对接', r: band('11-15', '6-10', '0-5') },
        { n: '工作过程考核-系统开发', max: 15, req: '系统功能模块开发、整体功能重构、突发事件处理、外部接口开发。', r: band('10-15', '5-9', '0-4') },
        { n: '工作过程考核-系统运维', max: 15, req: '服务器运维、日常系统运维、外部接口运维；保障系统运行稳定，确保系统功能使用正常。', r: band('10-15', '5-9', '0-4') },
        { n: '工作过程考核-测试交付', max: 15, req: '测试的完备性，测试报告的完整性，按计划实现项目交付', r: band('10-15', '5-9', '0-4') }
      ]},
      { name: '态度指标 10%', weight: 0.1, norm: true, items: [
        { n: '工作态度-积极性', max: 10, req: '工作积极性与主动性', r: band('8-10', '5-7', '0-4') },
        { n: '工作态度-纪律', max: 10, req: '是否严格遵守公司及部门各项行政纪律', r: band('8-10', '5-7', '0-4') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  // ---- 计划财务部 ----
  { ...KPI, key: 'KPI_FIN_CASHIER', deptCodes: ['FIN'],
    title: '出纳岗考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '基础工作', max: 35, req: '现金及银行存款的管理；发票管理；准确发放工资并及时申报个税；费用报销登记；及时准确发放贷款，零差错率', r: band('30-35', '25-29', '0-24') },
        { n: '贷款业务工作', max: 35, req: '放款前提条件核实；放款信息登记统计；收息及时准确；关注本金及付息逾期情况', r: band('30-35', '25-29', '0-24') },
        { n: '其他工作', max: 20, req: '工会出纳；领导交办的其他工作', r: band('15-20', '6-14', '0-5') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '责任心-协调沟通', max: 5, req: '内外部协调沟通能力', r: band('4-5', '2-3', '0-1') },
        { n: '责任心-保密工作', max: 5, req: '做好财务人员应有的保密工作', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_FIN_ACCOUNTANT', deptCodes: ['FIN'],
    title: '主办会计岗考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '统计工作', max: 30, req: '按规定节点向股东报投后管理表，数据真实有效；按时、准确上报股东单位财务报表；及时准确完成监管数据及信息报送', r: band('25-30', '10-24', '0-9') },
        { n: '财务基础工作', max: 30, req: '报帐、记帐、算帐；为绩效考核提供精准数据；控制公司各项费用、开支范围及标准；年底扎帐、财务决算；财务、税收、审计检查的准备和整收工作', r: band('25-30', '10-24', '0-9') },
        { n: '贷款工作', max: 20, req: '定期核实业务保证金；逾期项目的关注及金额核算；按时与其他部门同事核对业务数据，核实贷款各项目金额', r: band('15-20', '6-14', '0-5') },
        { n: '其他', max: 10, req: '工会会计；领导交代的其他事项', r: band('6-10', '1-5', '0') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '责任心-协调沟通', max: 5, req: '内外部协调沟通能力', r: band('4-5', '2-3', '0-1') },
        { n: '责任心-保密工作', max: 5, req: '做好保密工作', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' },
  { ...KPI, key: 'KPI_FIN_ASSISTANT', deptCodes: ['FIN'],
    title: '会计助理岗考核评分表', mode: 'SUM',
    groups: [
      { name: '能力指标 90%', weight: 1, items: [
        { n: '统计工作', max: 30, req: '及时准确向主管部门数据报送工作', r: band('25-30', '10-24', '0-9') },
        { n: '财务基础工作', max: 40, req: '帐目、财务凭证、报表、帐簿以及会计档案的整理、装订、归类、保管；配合出纳人员保证货币资金安全，账实相符；准确计算贷款利息，完成贷款业务台账登记', r: band('35-40', '20-34', '0-19') },
        { n: '其他', max: 20, req: '领导交代的其他事项', r: band('10-20', '1-9', '0') }
      ]},
      { name: '态度指标 10%', weight: 1, items: [
        { n: '责任心-协调沟通', max: 5, req: '内外部协调沟通能力', r: band('4-5', '2-3', '0-1') },
        { n: '责任心-保密工作', max: 5, req: '做好保密工作', r: band('4-5', '2-3', '0-1') }
      ]}
    ],
    note: '部门90分以上人员不得超过20%（不足1人的按1人计算）；95分以上和70分以下须写明原因，否则视为无效分。' }
]

/** 岗位管理-“绩效考核表”下拉选项：按部门分组（选项来自 KPI_FORMS） */
export const KPI_FORM_GROUPS = (() => {
  const labels = {
    BIZ1: '信贷业务部门', BIZ2: '信贷业务部门', RISK: '风险控制部门',
    TEC: '信息科技部门', PAG: '党政综合部门', FIN: '计划财务部门'
  }
  const map = {}
  KPI_FORMS.forEach(f => {
    const label = labels[f.deptCodes[0]] || f.deptCodes[0]
    if (!map[label]) map[label] = { label, forms: [] }
    map[label].forms.push(f)
  })
  return Object.values(map)
})()

/** 按 key 反查任意打分表（历史已评回显兑底用） */
export function formByKey(key) {
  if (!key) return null
  return FORMS.concat(KPI_FORMS, [PEER_FORM]).find(f => f.key === key) || null
}

/** 指定场景的内置打分表清单（供配置页下拉） */
export function formsOfScene(scene) {
  return FORMS.filter(f => f.scene === scene)
}

/** 全员互评可选用表（当前仅内置通用互评表，后续可扩展） */
export const PEER_FORMS = [PEER_FORM]

/** 按部门分组的下拉选项（与 KPI_FORM_GROUPS 同口径 labels） */
export function groupFormsByDept(forms) {
  const labels = {
    BIZ1: '信贷业务部门', BIZ2: '信贷业务部门', RISK: '风险控制部门',
    TEC: '信息科技部门', PAG: '党政综合部门', FIN: '计划财务部门'
  }
  const map = {}
  forms.forEach(f => {
    const label = labels[f.deptCodes[0]] || f.deptCodes[0]
    if (!map[label]) map[label] = { label, forms: [] }
    map[label].forms.push(f)
  })
  return Object.values(map)
}

/**
 * 匹配打分表：返回候选表数组
 * 全场景统一严格模式：只认 DB 配置的表key，未配置/配置无效返回空数组（页面显示未配置且不允许打分，无内置兜底）
 * key来源：LEADER_EMP/EMP_PEER=被评人岗位 kpi_form_key；ALL_PEER=被评人岗位 peer_form_key；
 * EMP_LEADER=被评负责人自己岗位 leader_form_key；EXEC_DEPT/LEADER_DEPT=被评部门两列（除前两者外均经 confFormKey 下发）
 * EXEC_ADJUST 无表（前端单独渲染加减分输入）
 */
export function matchForms(task) {
  if (!task) return []
  if (task.scene === 'EXEC_ADJUST') return []
  if (task.scene === 'LEADER_EMP' || task.scene === 'EMP_PEER') {
    return KPI_FORMS.filter(f => f.key === task.kpiFormKey)
  }
  if (task.scene === 'ALL_PEER') {
    // 注意 PEER_FORM 独立导出、不在 FORMS 数组内，故查表范围须并入它
    return FORMS.concat([PEER_FORM]).filter(f => f.key === task.confFormKey)
  }
  return FORMS.filter(f => f.key === task.confFormKey)
}

/** 计算总分（scores: { [groupIdx + '-' + itemIdx]: Number }） */
export function calcTotal(form, scores) {
  if (!form) return 0
  let total = 0
  form.groups.forEach((g, gi) => {
    let groupSum = 0
    g.items.forEach((it, ii) => {
      const v = scores[gi + '-' + ii]
      groupSum += (v === undefined || v === null || v === '' ? 0 : Number(v))
    })
    const gmax = g.items.reduce((a, it) => a + it.max, 0)
    total += form.mode === 'GROUP_WEIGHT' ? (g.norm && gmax > 0 ? groupSum / gmax * 100 : groupSum) * (g.weight || 1) : groupSum
  })
  return Math.round(total * 100) / 100
}
